import { dateFormatter, dateTimeFormatter, violationStatusFormatter } from '../../../utils/formatters';

export const violationColumns = [
  {
    dataField: 'resolution_number',
    headerClassName: 'number-violation-column',
    text: 'Номер постановления',
  },
  {
    dataField: 'resolution_at',
    headerClassName: 'resolution-date-column',
    text: 'Дата постановления',
    formatter: dateFormatter,
  },
  {
    dataField: 'koap',
    headerClassName: 'article-column',
    text: 'Состав АПН',
    // formatter: item => item.name,
  },
  {
    dataField: 'uin',
    headerClassName: 'uin-column',
    text: 'УИН',
  },
  {
    dataField: 'status',
    formatter: violationStatusFormatter,
    text: 'Статус',
  },
  {
    dataField: 'created_at',
    headerClassName: 'violation-date-column',
    text: 'Дата и время внесения записи',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'sum',
    headerClassName: 'fine-amount-column',
    text: 'Сумма штрафа',
  },
];
